// Centralized Supabase configuration values

export const SUPABASE_URL = "https://vjepgsqehezzlwctzyge.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqZXBnc3FlaGV6emx3Y3R6eWdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5NzY4ODcsImV4cCI6MjA2MDU1Mjg4N30.knFLEEHAM_QOE5gAvcAPrq9wql79g9DoTmO25GGkVRg";
